/* MYOB — Make Your Own Box. See sections/fn-myob-builder.liquid. */
(function () {
  var root = document.querySelector('[data-myob]');
  if (!root) return;

  var SIZE = parseInt(root.dataset.size, 10) || 6;
  var VARIANT = root.dataset.variant;
  var AVAILABLE = root.dataset.available === 'true';
  var STORE_KEY = 'fn-myob-box';
  var grid = root.querySelector('[data-myob-grid]');
  var tray = root.querySelector('[data-myob-tray]');
  var slotsEl = root.querySelector('[data-myob-slots]');
  var statusEl = root.querySelector('[data-myob-status]');
  var msgEl = root.querySelector('[data-myob-msg]');
  var cartBtn = root.querySelector('[data-myob-cart]');
  var clearBoxBtn = root.querySelector('[data-myob-clearbox]');
  var search = root.querySelector('[data-myob-search]');
  var countEl = root.querySelector('[data-myob-count]');
  var clearFilters = root.querySelector('[data-myob-clear]');

  var picks = []; // [{handle, name, img}] — duplicates allowed
  var q = '', state = { gender: '', scent: '' };

  try {
    var saved = JSON.parse(localStorage.getItem(STORE_KEY) || '[]');
    if (Array.isArray(saved)) picks = saved.slice(0, SIZE);
  } catch (e) {}

  function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify(picks)); } catch (e) {} }
  function flash(text) { msgEl.textContent = text || ''; if (text) setTimeout(function () { if (msgEl.textContent === text) msgEl.textContent = ''; }, 3500); }
  function qtyOf(handle) { return picks.filter(function (p) { return p.handle === handle; }).length; }
  function cards() { return grid.querySelectorAll('.fn-myob-card'); }

  function renderCards() {
    cards().forEach(function (card) {
      var n = qtyOf(card.dataset.handle), full = picks.length >= SIZE;
      var add = card.querySelector('.fn-myob-add'), step = card.querySelector('.fn-myob-step');
      var badge = card.querySelector('.fn-myob-card__count');
      add.hidden = n > 0; step.hidden = n === 0;
      step.querySelector('[data-qty]').textContent = n;
      step.querySelector('[data-act="plus"]').disabled = full;
      badge.hidden = n === 0; badge.textContent = '×' + n;
      card.classList.toggle('is-selected', n > 0);
    });
  }

  function renderTray() {
    slotsEl.innerHTML = '';
    for (var i = 0; i < SIZE; i++) {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'fn-myob-slot';
      var p = picks[i];
      if (p) {
        s.classList.add('is-filled');
        s.title = 'Remove ' + p.name;
        s.setAttribute('aria-label', 'Remove ' + p.name);
        s.dataset.index = i;
        s.innerHTML = p.img ? '<img alt="" src="' + p.img + '">' : '';
      } else {
        s.disabled = true;
        s.textContent = i + 1;
      }
      slotsEl.appendChild(s);
    }
    var left = SIZE - picks.length;
    statusEl.textContent = left === 0 ? 'Your box is full' : picks.length + ' of ' + SIZE + ' chosen — add ' + left + ' more';
    cartBtn.disabled = left !== 0 || !AVAILABLE || !VARIANT;
    if (!AVAILABLE && VARIANT) cartBtn.textContent = 'Sold out';
    clearBoxBtn.hidden = picks.length === 0;
  }

  function render() { renderCards(); renderTray(); save(); }

  function add(card) {
    if (picks.length >= SIZE) { flash('Your box is full — remove one to swap.'); return; }
    picks.push({ handle: card.dataset.handle, name: card.dataset.name, img: card.dataset.img });
    render();
  }
  function removeOne(handle) {
    for (var i = picks.length - 1; i >= 0; i--) { if (picks[i].handle === handle) { picks.splice(i, 1); break; } }
    render();
  }

  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var card = btn.closest('.fn-myob-card');
    var act = btn.dataset.act;
    if (act === 'add' || act === 'plus') add(card);
    else if (act === 'minus') removeOne(card.dataset.handle);
  });
  slotsEl.addEventListener('click', function (e) {
    var s = e.target.closest('.fn-myob-slot.is-filled');
    if (!s) return;
    picks.splice(parseInt(s.dataset.index, 10), 1);
    render();
  });
  clearBoxBtn.addEventListener('click', function () { picks = []; render(); });

  cartBtn.addEventListener('click', function () {
    if (picks.length !== SIZE) return;
    var props = {};
    picks.forEach(function (p, i) { props['Perfume ' + (i + 1)] = p.name; });
    cartBtn.disabled = true;
    var old = cartBtn.textContent; cartBtn.textContent = 'Adding…';
    fetch(root.dataset.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(VARIANT, 10), quantity: 1, properties: props }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add the box to your cart.');
        picks = []; save();
        window.location.href = root.dataset.cartUrl;
      })
      .catch(function (err) {
        flash(err.message);
        cartBtn.textContent = old; renderTray();
      });
  });

  /* ---- filters (same behaviour as the collection filter row) ---- */
  function applyFilters() {
    var shown = 0;
    cards().forEach(function (card) {
      var hay = (card.dataset.title + ' ' + card.dataset.scent + ' ' + card.dataset.gender).replace(/-/g, ' ');
      var ok = (!q || hay.indexOf(q) > -1) &&
               (!state.gender || card.dataset.gender === state.gender) &&
               (!state.scent || card.dataset.scent === state.scent);
      card.classList.toggle('is-hidden', !ok);
      if (ok) shown++;
    });
    countEl.textContent = shown + (shown === 1 ? ' perfume' : ' perfumes');
    clearFilters.hidden = !(q || state.gender || state.scent);
  }
  search.addEventListener('input', function () { q = search.value.trim().toLowerCase(); applyFilters(); });
  root.querySelectorAll('[data-myob-dd]').forEach(function (dd) {
    var key = dd.dataset.myobDd, label = dd.querySelector('[data-myob-label]'), base = label.textContent;
    label.dataset.base = base;
    dd.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        state[key] = b.dataset.value;
        dd.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        label.textContent = b.dataset.value ? b.textContent.trim() : base;
        dd.classList.toggle('is-active', !!b.dataset.value);
        dd.open = false;
        applyFilters();
      });
    });
  });
  clearFilters.addEventListener('click', function () {
    q = ''; search.value = ''; state.gender = ''; state.scent = '';
    root.querySelectorAll('[data-myob-dd]').forEach(function (dd) {
      var l = dd.querySelector('[data-myob-label]'); l.textContent = l.dataset.base;
      dd.classList.remove('is-active');
      dd.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-on', !x.dataset.value); });
    });
    applyFilters();
  });
  document.addEventListener('click', function (e) {
    root.querySelectorAll('.fn-myob__filters details[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });

  /* ---- the perfume list is paginated (50 per page): fetch the remaining pages ---- */
  var pages = parseInt(grid.dataset.pages, 10) || 1;
  function loadPage(n) {
    if (n > pages) return Promise.resolve();
    var url = new URL(location.href); url.searchParams.set('page', n);
    return fetch(url.toString()).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var have = {}; cards().forEach(function (c) { have[c.dataset.handle] = 1; });
      doc.querySelectorAll('.fn-myob-card').forEach(function (c) {
        if (have[c.dataset.handle]) return;
        grid.appendChild(document.importNode(c, true));
      });
    }).then(function () { return loadPage(n + 1); });
  }

  render(); applyFilters();
  loadPage(2).then(function () { render(); applyFilters(); });
})();
